<template>
  <div>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header color="rgb(230,230,230)" class="py-2">
          <span class="card-label bigger-label fw-bolder text-dark"
            >My PYB Address</span
          >
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="pt-2"></div>
          <v-row v-for="(info, i) in customerInfo" :key="i">
            <v-col cols="2" class="pb-0"><v-icon>{{info.icon}}</v-icon></v-col>
            <v-col class="pl-0 pb-0" :style="customerInfoStyle(info)" @click="copyToClipBoard(info)"><h3 class="mb-0"><em>{{info.value}}</em></h3></v-col>
          </v-row>
          <div class="pb-2"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <router-link
      v-if="this.showOrderBarrelButton"
      :to="{ name: 'Order' }"
      class="btn btn-primary fw-bold px-6 py-5 w-100 mt-6"
      >Order a barrel
      <svg
        width="22"
        height="23"
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.04956 11.6921H14.9056"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </router-link>
    <StackingNotification
      v-if="notifications.length > 0"
      :stackNotifications="notifications"
      @eClose="removeNotification"
      @eClearAll="clearAllNotification"
    />
  </div>
</template>

<script>

import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import StackingNotification from "@/components/StackingNotification.vue";
import StackingNotificationMixins from "@/mixins/StackingNotificationMixins";
import mixins from "vue-typed-mixins";
import {warehouse} from "@/config/address.json"

export default mixins(StackingNotificationMixins).extend({
  name: "MyBarrels",
  components: {StackingNotification},
  props: {
    providedNumber: String,
    customerName: String,
    showOrderBarrelButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      retrievedNumber: "",
    };
  },
  computed: {
    customerInfo(){
      return [
        {icon: 'mdi-account-circle',value: `${this.customerName}`},
        {icon: 'mdi-map-marker',value: `${warehouse.addressLine1}, ${warehouse.addressLine2}`, underline: true, copy: true},
        {icon: 'mdi-map-marker',value: `PYB#${this.pybNumber}`, underline: true, copy: true},
        {icon: 'mdi-map-marker',value: `${warehouse.city} ${warehouse.stateShortName} ${warehouse.zipCode}`, underline: true, copy: true}
      ]
    },
    pybNumber() {
      if (this.providedNumber) return this.providedNumber;
      return this.retrievedNumber;
    },
  },
  methods: {
    customerInfoStyle(info){
      let style = '';
      if(info.underline) style += 'text-decoration: underline dotted blue;'
      if(info.copy) style += 'cursor:pointer;'
      return style
    },
    copyToClipBoard(info){
      if(info.copy){
        navigator.clipboard.writeText(info.value);
        this.addNotification({
          message: `${info.value} Copied To Clipboard`
        });
      }
    }
  },
  async beforeMount() {
    try {
      if (!this.providedNumber) {
        let result = await ApiService.Instance.customerHomepage();
        this.retrievedNumber = result.pybNumber;
      }
    } catch (e) {
      error(e);
    }
  },
});
</script>
